import { render, staticRenderFns } from "./SideMatchStatusAlert.vue?vue&type=template&id=2176260d&scoped=true&"
import script from "./SideMatchStatusAlert.vue?vue&type=script&lang=ts&"
export * from "./SideMatchStatusAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2176260d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
